import React from 'react';
import './WhatWeDo.scss';
import iconEnterprise from '../Assets/Images/icon-enterprise.svg';
import iconPowerPlay from '../Assets/Images/icon-power-play-new.svg';
import photoEnterprise from '../Assets/Images/EA.webp';
import photoPowerPlay from '../Assets/Images/PP.webp';
import vectorBg from '../Assets/Images/whatwedo-vector-bg.svg';
import vectorBgMobile from '../Assets/Images/whatwedo-vector-bg-mobile.png';
import { useInView } from '../hooks/useInView';

const services = [
  {
    photo: photoEnterprise,
    icon: iconEnterprise,
    title: 'Enterprise\nArchitecture',
    description:
      'The structural backbone of your digital enterprise, that aligns your business strategy and technology. Jointly map what you have, design what you need, and produce a roadmap to get you there, tied to real projects and real constraints.',
    link: '/enterprisearchitecture',
  },
  {
    photo: photoPowerPlay,
    icon: iconPowerPlay,
    title: 'Power\nPlay',
    description:
      'By analyzing business processes and needs, we turn fragmented and manual workflows into structured, automated applications in weeks, not months. Business teams stay in control. IT gets visibility, scale and security without the bottlenecks.',
    link: '/powerplay',
  },
];

function WhatWeDo() {
  const { ref: textRef, visible: textVisible } = useInView();
  const { ref: cardsRef, visible: cardsVisible } = useInView();

  return (
    <section className='what-we-do'>
      <div className='what-we-do-bg'>
        <img className='bg-desktop' src={vectorBg} alt="" />
        <img className='bg-mobile' src={vectorBgMobile} alt="" />
      </div>

      <div className='what-we-do-inner'>
        <div
          className={`what-we-do-text anim-fade-up${textVisible ? ' is-visible' : ''}`}
          ref={textRef as React.RefObject<HTMLDivElement>}
        >
          <h2 className='what-we-do-title'>
            <span className='orange'>Our</span> services
          </h2>
          <p className='what-we-do-desc'>
            Your strategy is only as strong as the system behind it. We build the digital backbone that
            connects your goals, data, and technology. Architecture and automation work as one, turning
            slow, manual workflows into applications that scale, so your organization moves faster
            without starting from scratch.
          </p>
        </div>

        <div
          className={`what-we-do-cards${cardsVisible ? ' cards-visible' : ''}`}
          ref={cardsRef as React.RefObject<HTMLDivElement>}
        >
          {services.map((service, index) => (
            <a
              className='service-card'
              key={index}
              href={service.link}
              target="_blank"
              rel="noreferrer"
              style={{ animationDelay: `${index * 0.15}s`, textDecoration: 'none', color: 'inherit' }}
            >
              <div className='service-card-photo'>
                <img src={service.photo} alt="" />
              </div>
              <div className='service-card-body'>
                <div className='service-card-header'>
                  <img className='service-card-icon' src={service.icon} alt="" />
                  <h3 className='service-card-title'>
                    {service.title.split('\n').map((line, i, arr) => (
                      <React.Fragment key={i}>
                        {line}{i < arr.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </h3>
                </div>
                <p className='service-card-desc'>{service.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
